/**
 * RemovePullContentCommand.js
 *
 * @author Olivier van der Pool for Ranj
 **/
export default class RemovePullContentCommand {
    constructor(pullContentManager) {
        this._pullContentManager = pullContentManager;

        this.execute = function(event) {
            this._pullContentManager.removePullContent(event.params.data.content);
        };
    }
}
